import { OrderRequest } from '@core/data-access/models/save-order/order-request.model';
import { OrderResponseModel } from '@core/data-access/models/save-order/order-response.model';
import { OrderPayloadModel } from '@core/data-access/models/save-order/order-store.model';
import { Action } from '@ngrx/store';
import {
  FormInputsPayloadModel,
  FormStatusPayloadModel,
  SetStepFormsValidity as SetStepFormsValidityPayload,
  StepName,
  StepsFormsActionName,
  VisibilityPayloadModel
} from '@store/step-forms/step.interface';

export const enum ActionTypes {
  SET_SELECTED_STEP = '[StepsForms] Set name of selected step',
  SET_FORM_INPUTS = '[StepsForms] Set input set to given form',
  REMOVE_FORM = '[StepsForms] Remove input set and form',
  SET_FORM_VALIDITY = '[StepsForms] Set validity of given form',
  REMOVE_FORMS_VALIDITY = '[StepsForms] Remove validity of array of forms',
  SET_STEP_FORMS_VALIDITY = '[StepsForms] Set step forms validity',
  SET_STEP_VISIBILITY = '[StepsForms] Set visibility of given step',
  SET_MULTIPLE_STEPS_VISIBILITY = '[StepsForms] Set visibility of multiple steps',
  SET_STEP_ORDER = '[StepsForms] Set new order number of a step',
  SET_CONTINUE_AS_GUEST = '[StepsForms] Set value of checkbox continue as guest',
  SEND_ORDER = '[StepsForms] Send the whole order',
  SET_PAYMENT_METHOD = '[StepsForms] Set payment service',
  SET_ORDER_RESPONSE = '[StepsForms] Set order response',
  SET_ANONYMOUS_HIDDEN_STEPS = '[StepsForms] Hide steps if anonymous ticket taken',
  RESET_REDUCER = '[StepsForms] reset reducer'
}
/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */

export class SetSelectedStep implements Action {
  readonly type = ActionTypes.SET_SELECTED_STEP;
  constructor(public payload: StepName) {}
}

export class RemoveForm implements Action {
  readonly type = ActionTypes.REMOVE_FORM;
  constructor(public payload: StepsFormsActionName) {}
}

export class SetInputs implements Action {
  readonly type = ActionTypes.SET_FORM_INPUTS;
  constructor(public payload: FormInputsPayloadModel) {}
}

export class SetFormValidity implements Action {
  readonly type = ActionTypes.SET_FORM_VALIDITY;
  constructor(public payload: FormStatusPayloadModel) {}
}

export class RemoveFormValidity implements Action {
  readonly type = ActionTypes.REMOVE_FORMS_VALIDITY;
  constructor(public payload: FormStatusPayloadModel[]) {}
}

export class SetStepFormsValidity implements Action {
  readonly type = ActionTypes.SET_STEP_FORMS_VALIDITY;
  constructor(public payload: SetStepFormsValidityPayload) {}
}

export class SetStepsVisibility implements Action {
  readonly type = ActionTypes.SET_STEP_VISIBILITY;
  constructor(public payload: VisibilityPayloadModel[]) {}
}

export class SetMultipleStepsVisibility implements Action {
  readonly type = ActionTypes.SET_MULTIPLE_STEPS_VISIBILITY;
  constructor(public payload: VisibilityPayloadModel[]) {}
}

export class SetStepOrder implements Action {
  readonly type = ActionTypes.SET_STEP_ORDER;
  constructor(public payload: OrderPayloadModel) {}
}

export class SetContinueAsGuest implements Action {
  readonly type = ActionTypes.SET_CONTINUE_AS_GUEST;
  constructor(public payload: boolean) {}
}

export class SendOrder implements Action {
  readonly type = ActionTypes.SEND_ORDER;
  constructor(public payload: OrderRequest) {}
}

export class SetOrderResponse implements Action {
  readonly type = ActionTypes.SET_ORDER_RESPONSE;
  constructor(public payload: OrderResponseModel) {}
}

export class SetPaymentMethod implements Action {
  readonly type = ActionTypes.SET_PAYMENT_METHOD;
  constructor(public payload: string) {}
}

export class SetAnonymousHiddenSteps implements Action {
  readonly type = ActionTypes.SET_ANONYMOUS_HIDDEN_STEPS;
  constructor(public payload: StepName[]) {}
}

export class ResetReducer implements Action {
  readonly type = ActionTypes.RESET_REDUCER;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | SetSelectedStep
  | RemoveForm
  | SetInputs
  | SetFormValidity
  | RemoveFormValidity
  | SetStepFormsValidity
  | SetStepsVisibility
  | SetMultipleStepsVisibility
  | SetStepOrder
  | ResetReducer
  | SetContinueAsGuest
  | SendOrder
  | SetOrderResponse
  | SetPaymentMethod
  | SetAnonymousHiddenSteps;
